<template>
  <div class="holiday-rank-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" :title="$t('lang.commonM.k229')" left-arrow @click-left="handleBack" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right">
            <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="rank-bg" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <img src="./images/rank-bg.png" />
    </div>

    <div class="bg-block">
      <div class="holiday-rank-bar">
        <!-- 1-3 -->
        <div class="prize">
          <div class="two">
            <img class="rank_c2_avatar" :src="prize2.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-two.png" />
            </div>
            <div class="item-num">
              <span class="name">{{ prize2.nickname || '--' }}</span>
              <span class="num">
                {{ prize2.score || '--' }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>

          <div class="prize-gap"></div>

          <div class="one">
            <img class="rank_c1_avatar" :src="prize1.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-one.png" />
            </div>
            <div class="item-num">
              <span class="name">{{ prize1.nickname || '--' }}</span>
              <span class="num">
                {{ prize1.score || '--' }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>

          <div class="prize-gap"></div>

          <div class="three">
            <img class="rank_c3_avatar" :src="prize3.avatar | imgPath" alt="" />
            <div class="rank-sort">
              <img src="./images/n-three.png" />
            </div>
            <div class="item-num kiss-num3">
              <span class="name">{{ prize3.nickname || '--' }}</span>
              <span class="num">
                {{ prize3.score || '--' }}
                <i>({{ $t('lang.valRuFe.points') }})</i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="holiday-rank-con">
        <div class="rank-special-head">
          <div class="rank-sty-bg2">
            <div class="rank-sty-bg3"></div>
          </div>
        </div>

        <!-- list -->
        <div class="rank-body">
          <div v-if="ended === false" class="tit-time">
            <span class="time">{{ $t('lang.kissGf.ranking') }}</span>
            <span class="time">{{ actStartTime }}-{{ actEndTime }}</span>
          </div>
          <div v-else class="time-tips tips-end">{{ $t('lang.commonM.k242') }}</div>

          <template v-if="rankList.length > 0">
            <div class="agent-item" v-for="item in rankList" :key="item">
              <span class="rank-num" v-if="item.rank">{{ item.rank }}</span>
              <div class="avatar rank-avatar">
                <img :src="item.avatar | imgPath" alt="" />
                <span>{{ item.nickname }}</span>
              </div>
              <div class="item-num">
                {{ item.score }}
                <i>{{ $t('lang.valRuFe.points') }}</i>
              </div>
            </div>
          </template>
        </div>

        <!-- owner -->
        <div class="agent-item owner-item" v-if="owners" :style="{ 'margin-bottom': `${bottomBarHeight}px` }">
          <div class="owner-item-content">
            <div class="avatar">
              <span v-if="owners.rank" class="rank-num">{{ owners.rank }}</span>
              <span v-else class="rank-num not-in-rank">--</span>
              <div class="avatar-box">
                <img :src="owners.avatar | imgPath" alt="" />
                <div class="avatar-txt">
                  <span>{{ owners.nickname }}</span>
                  <div v-if="!owners.rank">{{ $t('lang.ween.noRanking') }}</div>
                </div>
              </div>
            </div>
            <div class="item-num">
              {{ owners.score || 0 }}
              <i>{{ $t('lang.valRuFe.points') }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo, holidayActRank } from './apidir/api.js'

export default {
  data() {
    return {
      bottomBarHeight: 0,
      title: '',
      actStartTime: '',
      actEndTime: '',
      ended: false,
      prize1: {},
      prize2: {},
      prize3: {},
      rankList: [],
      owners: {}
    }
  },
  methods: {
    handleBack() {
      if (this.$route.query.from === 'newyearsday-main-male') {
        this.goPrevious()
        return
      }
      this.closeWeb()
    },
    // 规则
    handleToRule() {
      this.$router.push({ path: '/newyearsday-rules-male', query: { from: 'newyearsday-rank-male' } })
    },
    // 获取数据
    fetchRanking() {
      holidayActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          if (resData.startTimestamp) {
            this.actStartTime = this.handleMoment(resData.startTimestamp, 'MM.DD')
          }
          if (resData.endTimestamp) {
            this.actEndTime = this.handleMoment(resData.endTimestamp, 'MM.DD')
          }
        }
      })

      holidayActRank().then((resData) => {
        if (resData && !resData.error) {
          this.ended = !!resData.ended

          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}

            // 已排名
            if (this.prize1.rank) {
              this.rankList = resData.ranks && resData.ranks.slice(3)
            }
            // 未排名
            else {
              this.rankList = resData.ranks
            }
          }

          // 用户数据
          if (resData.owners) {
            this.owners = resData.owners
          }
        }
      })
    },
    // 模拟数据
    mockRanking() {
      const resData = {
        ended: false,
        owners: {
          avatar: 'public/picture/2023-07-07/acf4942604ecae168398d19c38d92423.jpg',
          gifts: 0,
          nickname: 'Greenwalt',
          points: 0,
          presentId: '1079',
          uid: 1079,
          rank: 4
        },
        ranks: [
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            rank: 0
          },
          {
            avatar: 'public/app/picture/250811/1754894841342f450882ee3d50e52R7896.jpg',
            gifts: 13,
            nickname: '786err',
            presentId: '2668406',
            uid: 4817,
            rank: 2
          },
          {
            avatar: 'public/app/picture/250322/17426127406309b7cdeac-9ea6-4467-b9c8-d94bdc690d4dR3378.jpg',
            gifts: 12,
            nickname: '452hshd',
            presentId: '9360241',
            uid: 4001,
            rank: 3
          },
          {
            avatar: 'public/app/picture/250322/1742610682602e1d496b8-7c2d-4929-8c89-fca80b541349R1592.jpg',
            gifts: 10,
            nickname: '450shs',
            presentId: '5860232',
            uid: 4000,
            rank: 4
          }
        ]
      }

      if (resData) {
        // 排名数据
        if (resData.ranks && resData.ranks.length > 0) {
          // 活动最后一天 用points， 前几天用gifts
          resData.ranks.forEach((rankItem) => {
            rankItem.score = rankItem.gifts || rankItem.points
          })

          // 前三名
          this.prize1 = resData.ranks[0] || {}
          this.prize2 = resData.ranks[1] || {}
          this.prize3 = resData.ranks[2] || {}

          // 已排名
          if (this.prize1.rank) {
            this.rankList = resData.ranks && resData.ranks.slice(3)
          }
          // 未排名
          else {
            this.rankList = resData.ranks
          }
        }

        // 用户数据
        if (resData.owners) {
          this.owners = resData.owners
        }
      }
    }
  },
  created() {
    // this.mockRanking()
    this.fetchRanking()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  }
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.holiday-rank-root {
  width: 100%;
  min-height: 100vh;
  background: #ae182c;

  .custom-nav-block {
    background: url(./images/rank-bg.png) top left / 100% auto no-repeat;
  }

  .rank-bg {
    width: 100%;
    position: relative;
    img {
      width: 100%;
    }
  }

  .bg-block {
    position: relative;

    .holiday-rank-bar {
      position: relative;
      margin-bottom: 12px;
      .prize {
        width: 100%;
        margin: 0 auto;
        padding: 0 28px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .prize-gap {
          width: 11px;
        }
        .one,
        .two,
        .three {
          width: 90px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          padding: 8px 0;
          border-radius: 8px;
          background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);

          .item-num {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .name {
              font-size: 15px;
              padding: 0 6px;
              color: #fbf3f1;
              margin-top: 8px;
              width: 100%;
              overflow: hidden;
              text-align: center;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .num {
              margin-top: 10px;
              display: flex;
              align-items: center;
              font-family: 'TikTokSans-Regular';
              font-weight: 600;
              font-size: 17px;
              color: #fbf3f1;
              text-align: center;
              display: inline-flex;
              align-items: center;

              i {
                font-weight: 400;
                font-size: 12px;
              }
            }
          }
        }
        .one {
          .rank_c1_avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #ffcd55;
          }
          .rank-sort {
            width: 70px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
        .two {
          .rank_c2_avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #dadee7;
          }
          .rank-sort {
            width: 60px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
        .three {
          .rank_c3_avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid #d39d58;
          }
          .rank-sort {
            width: 60px;
            margin-top: 8px;
            img {
              width: 100%;
            }
          }
        }
      }
    }

    .holiday-rank-con {
      min-height: 80vh;
      padding-bottom: 90px;
      .rank-special-head {
        width: 371px;
        height: 36px;
        margin: 0 auto;
        border-radius: 18px;
        background: linear-gradient(90deg, #caccce -3.3%, #fff 50.65%, #caccce 102.93%);
        display: flex;
        align-items: center;
        justify-content: center;
        .rank-sty-bg2 {
          width: 367px;
          height: 32px;
          border: 0.5px solid #ffffff;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          .rank-sty-bg3 {
            width: 351px;
            height: 10px;
            border-radius: 5px;
            background: linear-gradient(134deg, #ff4140 12.7%, #f3ae1d 54.56%);
          }
        }
      }
      .rank-body {
        width: 343px;
        min-height: 450px;
        margin: -18px auto 0;
        padding: 16px;
        background: #fffcf0;
        border-radius: 0px 0px 16px 16px;
        position: relative;
        .tit-time {
          font-family: 'Roboto Flex';
          font-weight: 400;
          font-size: 15px;
          line-height: 19px;
          color: #333333;
          overflow: hidden;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .time-tips {
          color: #333;
          text-align: center;
          font-family: 'Roboto Flex';
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: 17px;
          margin-bottom: 12px;
        }
        .first-tip {
          margin-bottom: 5px;
        }
        .tips-end {
          letter-spacing: -0.5px;
        }
      }
      .agent-item {
        height: 40px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: Inter-Regular;
        &:last-child {
          margin-bottom: 0;
        }
        .rank-num {
          display: block;
          min-width: 18px;
          margin-right: 6px;
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
        }
        .avatar {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-family: Roboto Flex;
          color: #af2f3a;
          > img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            object-fit: cover;
          }
        }
        .rank-avatar {
          flex: 1 !important;
        }
        .item-num {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 20px;
          color: #ffba3b;
          font-family: Roboto Flex;
          > img {
            width: 28px;
            height: 25px;
            margin-left: 10px;
          }
          i {
            font-weight: 400;
            padding-left: 6px;
            font-size: 14px;
            color: #af2f3a;
          }
        }
      }
      .owner-item {
        width: 375px;
        height: 69px;
        position: fixed;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        background: #ff4140;
        .owner-item-content {
          width: 343px;
          height: 100%;
          margin: 0 auto;
          padding: 16px 9px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .avatar {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            .rank-num {
              color: #ffffff;
              font-family: 'TikTokSans-Regular';
              font-size: 17px;
              font-weight: bold;
            }
            .not-in-rank {
              font-size: 17px;
            }
            .avatar-box {
              display: flex;
              align-items: center;
              > img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: cover;
              }
              .avatar-txt {
                display: inline-block;
                width: 115px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0 5px;
                font-family: Inter-Regular;
                font-weight: normal;
                color: #ffffff;
                span {
                  font-size: 17px;
                  line-height: 20px;
                }
                div {
                  font-size: 12px;
                  line-height: 16px;
                  opacity: 0.7;
                }
              }
            }
          }
          .item-num {
            color: #ffffff;
            i {
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}

// .holiday-rank-root.no-sort {
//   .custom-nav-block {
//     background: url(./images/norank-bg.png) top left / 100% auto no-repeat;
//   }
//   .rank-bg {
//     width: 100%;
//     height: fit-content;
//     position: relative;

//     img {
//       width: 100%;
//     }
//   }

//   .bg-block {
//     position: relative;
//     margin-top: -100px;
//     .holiday-rank-con {
//       .rank-body {
//         border-radius: 16px;
//         margin: 0 auto;
//       }
//     }
//   }
// }

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTokSans-Regular';
  font-weight: 600;
  color: #ffffff;
}
::v-deep .van-nav-bar__right .tit-right {
  line-height: 16px !important;
}
</style>
